import React from "react";

import Scoped from "@app/scene/dashboard/types/Scoped";

import DefaultPreferencesFormComponent from "../common/DefaultPreferencesFormComponent";

interface Props extends Scoped {}

const PreferencesFormComponent: React.FC<Props> = ({ scope }) => {
  return <DefaultPreferencesFormComponent scope={scope} showRankPosition={false} />;
};

export default PreferencesFormComponent;
